<template>
	<div class="table-mapper-input-field">
		<v-input :ref="fieldRef" data-lpignore="true" v-model="value" v-bind="activeFormFieldCommonProps" hide-details>
			<div class="importer-container" v-if="preStepData && preStepHeaders">
				<TableMapperMiniApp
					class="flex-1"
					:headers="preStepHeaders"
					:columnOptions="columnOptions"
					:rows="preStepData"
					:finalResult="resultTable"
					:isHeadersMappingMode="isHeadersMappingMode"
					@onResultTableChanged="onResultTableChanged"
					@on-mini-app-finished="$emit('on-mini-app-finished')"
					@on-mini-app-cancel="$emit('on-mini-app-cancel')"
				/>
			</div>
		</v-input>
	</div>
</template>

<script>
import MultiItemSourceFieldMixin from '../MultiItemSourceField/MultiItemSourceFieldMixin';
import { flattenPreserveArrays } from '@/utils/helpers';
import WidgetFieldMixin from '../WidgetFieldMixin';
import WidgetFieldTableOptionsMixin from '../WidgetFieldTableOptionsMixin';
import TableMapperMiniApp from './TableMapperMiniApp';

export default {
	name: 'TableMapperInputField',
	components: {
		TableMapperMiniApp,
	},
	props: {},
	mixins: [WidgetFieldMixin, MultiItemSourceFieldMixin, WidgetFieldTableOptionsMixin],
	computed: {
		preStepHeaders() {
			if (!this.preStepData || this.preStepData.length === 0) {
				return null;
			}
			return Object.keys(this.preStepData[0]);
		},
		preStepData() {
			const preStepFlattened = flattenPreserveArrays(this.preStep || []);
			const dummyRowWithHeaders =
				preStepFlattened.length > 0 ? Object.keys(preStepFlattened[0]).reduce((result, key) => ({ [key]: key, ...result }), {}) : [];
			return [dummyRowWithHeaders, ...preStepFlattened];
		},
		editModeHeaders() {
			if (!this.editModeTableRows || this.editModeTableRows.length === 0) {
				return [];
			}
			return Object.keys(this.editModeTableRows[0]);
		},
		editModeTableRows() {
			return this.previousStepsEditMode;
		},
		columnOptions() {
			return this.isTableOptionsMode ? this.dynamicTableOptions : this.field.metadata.options?.columns_options || [];
		},
		isEditable() {
			return this.fieldOptions.editable.enabled;
		},
		isHeadersMappingMode() {
			return !!this.fieldOptions.headers_mapping_mode.enabled;
		},
	},
	methods: {
		onResultTableChanged(newTable) {
			this.resultTable = newTable;
			this.value = newTable;
		},
	},
	data() {
		return {
			resultTable: [],
		};
	},
};
</script>

<style scoped lang="scss">
.table-mapper-input-field {
	$border-color: var(--forth-border-color);
	text-align: left;

	.importer-container {
		width: 100%;
		overflow: auto;
	}

	.empty-state {
		height: 100px;
		border: 1px solid #d6ddeb;
		border-radius: 7px;
		color: #354052;
		font-weight: 200;
		background-color: #ffffff;
	}
	.bottom-bar {
		padding: 4px 15px;
		font-size: 11px;
		font-weight: 200px;
		border-top: 1px solid $border-color;
		background-color: #fff;

		span {
			margin-left: 8px;
		}
	}

	::v-deep {
		$table-mapping-title-height: 48px;

		.table-view {
			height: 100%;
		}
		.ag-cell {
			border: none !important;
		}
	}
}
</style>
